<template> 
    <h1 class="cRed">/404</h1>
</template> 
<script>
   
    export default {
        data () {
            return {
             
            }
        },
        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style>
    
</style>
     